import CurrencyAmount from './currency-amount.vue';

export default CurrencyAmount;
